var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.350725 7.86891L8.05002 0.175224C8.10546 0.119678 8.17131 0.0756107 8.24379 0.0455436C8.31628 0.0154765 8.39399 0 8.47247 0C8.55094 0 8.62865 0.0154765 8.70114 0.0455436C8.77362 0.0756107 8.83947 0.119678 8.89491 0.175224L16.5942 7.86891C16.8185 8.09322 16.9456 8.3979 16.9456 8.71567C16.9456 9.3755 16.4092 9.91197 15.7493 9.91197H14.9381V15.4019C14.9381 15.7327 14.6708 16 14.3399 16H9.66876V11.813H7.57524V16H2.605C2.27415 16 2.00685 15.7327 2.00685 15.4019V9.91197H1.19561C0.877844 9.91197 0.573162 9.78673 0.348856 9.56055C-0.116579 9.09325 -0.116579 8.33622 0.350725 7.86891Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic-home.a8921e7a.svg";
export { ForwardRef as ReactComponent };